import ReactIcon from '../../assets/images/react-icon.png'
import NextIcon from '../../assets/images/nextjs-logo.webp'
import TypescriptIcon from '../../assets/images/typescript-logo.png'
import JavaScriptIcon from '../../assets/images/javascript-icon.png'
import NodeIcon from '../../assets/images/nodejs-logo.png'
import ReduxIcon from '../../assets/images/redux-icon.png'
import FirebaseIcon from '../../assets/images/firebase-icon.png'
import StoryBook from '../../assets/images/storybook-icon.png'
import NestIcon from '../../assets/images/nestjs.png'
import SaasIcon from '../../assets/images/saas.png'
import TailwindCss from '../../assets/images/tailwind-css.png'

export const skills = [
  {
    id: 1,
    tecnology: {
      pt: 'React Native',
      en: 'React Native'
    },
    description: {
      pt: 'React Native é usada para desenvolver aplicativos para os sistemas Android e iOS de forma nativa',
      en: 'React Native is used to build native applications for Android and iOS systems.'
    },
    image: ReactIcon
  },
  {
    id: 2,
    tecnology: {
      pt: 'React.js',
      en: 'React.js'
    },
    description: {
      pt: 'O React é uma biblioteca front-end JavaScript de código aberto com foco em criar interfaces de usuário em páginas web.',
      en: 'React is an open-source JavaScript front-end library focused on building user interfaces for web pages.'
    },
    image: ReactIcon
  },
  {
    id: 3,
    tecnology: {
      pt: 'Typescript',
      en: 'Typescript'
    },
    description: {
      pt: 'Typescript é uma linguagem de programação que é um superconjunto sintático estrito de JavaScript e adiciona tipagem estática opcional à linguagem.',
      en: 'TypeScript is a programming language that is a strict syntactical superset of JavaScript and adds optional static typing to the language.'
    },
    image: TypescriptIcon
  },
  {
    id: 4,
    tecnology: {
      pt: 'Javascript',
      en: 'Javascript'
    },
    description: {
      pt: 'É uma linguagem de programação interpretada estruturada, de script em alto nível com tipagem dinâmica fraca e multiparadigma.',
      en: 'JavaScript is a high-level, interpreted scripting language with weak dynamic typing and multi-paradigm support.'
    },
    image: JavaScriptIcon
  },
  {
    id: 5,
    tecnology: {
      pt: 'Next.js',
      en: 'Next.js'
    },
    description: {
      pt: 'Next.js permite criar aplicativos web de alta qualidade com o poder dos componentes React.',
      en: 'Next.js enables the creation of high-quality web applications using the power of React components.'
    },
    image: NextIcon
  },
  {
    id: 6,
    tecnology: {
      pt: 'Node.js',
      en: 'Node.js'
    },
    description: {
      pt: 'Node.js é um software de código aberto, multiplataforma, que permite a execução de códigos JavaScript fora de um navegador web.',
      en: 'Node.js is an open-source, cross-platform runtime that allows JavaScript code to run outside a web browser.'
    },
    image: NodeIcon
  },
  {
    id: 7,
    tecnology: {
      pt: 'Redux.js',
      en: 'Redux.js'
    },
    description: {
      pt: 'Redux é uma biblioteca JavaScript de código aberto para gerenciar o estado do aplicativo.',
      en: 'Redux is an open-source JavaScript library for managing application state.'
    },
    image: ReduxIcon
  },
  {
    id: 8,
    tecnology: {
      pt: 'Firebase',
      en: 'Firebase'
    },
    description: {
      pt: 'É um conjunto de serviços de computação em nuvem de back-end e plataformas de desenvolvimento de aplicativos fornecidos pelo Google.',
      en: 'Firebase is a set of cloud computing services and application development platforms provided by Google.'
    },
    image: FirebaseIcon
  },
  {
    id: 9,
    tecnology: {
      pt: 'Storybook',
      en: 'Storybook'
    },
    description: {
      pt: 'Storybook é um workshop de front-end para a construção de componentes e páginas de UI isoladamente.',
      en: 'Storybook is a front-end workshop for building UI components and pages in isolation.'
    },
    image: StoryBook
  },
  {
    id: 10,
    tecnology: {
      pt: 'Sass',
      en: 'Sass'
    },
    description: {
      pt: 'Sass é um pré-processador CSS que estende as funcionalidades do CSS tradicional, permitindo o uso de variáveis, aninhamento, mixins e mais.',
      en: 'Sass is a CSS preprocessor that extends traditional CSS with features like variables, nesting, mixins, and more.'
    },
    image: SaasIcon
  },
  {
    id: 11,
    tecnology: {
      pt: 'NestJS',
      en: 'NestJS'
    },
    description: {
      pt: 'NestJS é um framework de back-end para a construção de aplicações Node.js escaláveis e eficientes.',
      en: 'NestJS is a back-end framework for building scalable and efficient Node.js applications.'
    },
    image: NestIcon
  },
  {
    id: 12,
    tecnology: {
      pt: 'TailwindCss',
      en: 'TailwindCss'
    },
    description: {
      pt: 'TailwindCSS é um framework de utilitários para estilização rápida e consistente de interfaces.',
      en: 'TailwindCSS is a utility-first framework for fast and consistent interface styling.'
    },
    image: TailwindCss
  }
];
